@if (tddConfigArray) {
  <div class="tdd-option">
    <ul class="tdd-slot-list">
      @for (slot of tddConfigArray; track slot) {
        <li class="tdd-slot tdd-slot-{{ slot.toLowerCase() }}">
          {{ slot.toUpperCase() }}
        </li>
      }
    </ul>
  </div>
}
